const $ = jQuery;
const _window = $(window);
const Slider = {
	init: () => {
		$('.section-intro--slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: $('.section-intro--slider-prev'),
			nextArrow: $('.section-intro--slider-next'),
			dots: true,
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 800,
			fade: true,
			pauseOnFocus: true,
			responsive: [
				{
					breakpoint: 640,
					settings: {
						arrows: false,
						prevArrow: false,
						nextArrow: false,
					},
				},
			],
		});
	},
};
export default Slider;
